import React from "react";
import Layout from "../components/Layout";
import SEOHead from "../components/SEOHead";
import PageHeader from "../components/PageHeader";
import { IconCompliance, IconGovernment, IconCyber, IconInfrastructure } from "../brand/icons";

const About = () => (
  <Layout>
    <SEOHead title="About AuditIQ | Government Accountability & Infrastructure Cybersecurity" path="/about"
      description="AuditIQ unites budget transparency, AI risk analysis, and critical-infrastructure cybersecurity into one executive-grade platform." />
    <PageHeader eyebrow="About" title="Accountability, engineered."
      subtitle="AuditIQ was founded to close the gap between public budgets, community infrastructure, and the operational technology that keeps critical systems running. We pair AI-powered analysis with a defensive-only cybersecurity posture." />
    <section className="max-w-[1400px] mx-auto px-6 py-20 grid md:grid-cols-2 gap-10">
      <div className="panel-elev p-8">
        <IconGovernment size={28} />
        <h3 className="font-display text-xl mt-4">Who we serve</h3>
        <p className="text-sm text-cream-dim mt-3 leading-relaxed">
          City and county governments, school districts, special districts, data
          center operators, and civic accountability advocates who need
          decision-grade signals without accusation-grade language.
        </p>
      </div>
      <div className="panel-elev p-8">
        <IconCyber size={28} />
        <h3 className="font-display text-xl mt-4">Defensive by design</h3>
        <p className="text-sm text-cream-dim mt-3 leading-relaxed">
          We do not build offensive tooling. CyberWater monitors device identity,
          sensor integrity, and command validity across water systems — and
          escalates, never exploits.
        </p>
      </div>
      <div className="panel-elev p-8">
        <IconInfrastructure size={28} />
        <h3 className="font-display text-xl mt-4">Infrastructure-first</h3>
        <p className="text-sm text-cream-dim mt-3 leading-relaxed">
          Our recommendations are framed around community benefit — drainage,
          water, public safety, parks, resilience, and technology modernization.
        </p>
      </div>
      <div className="panel-elev p-8">
        <IconCompliance size={28} />
        <h3 className="font-display text-xl mt-4">Non-partisan posture</h3>
        <p className="text-sm text-cream-dim mt-3 leading-relaxed">
          Findings are framed as preliminary analysis, decision-support, and
          review-worthy indicators — never legal claims. Residents get
          questions worth asking; officials get clear reallocation options.
        </p>
      </div>
    </section>
  </Layout>
);

export default About;
